import { useRecoilValue } from 'recoil';
import IcomoonReact from 'icomoon-react';
import iconSet from '@sentinel-one/font-mgmt/selection.json';

import { iconStylesState } from 'styles/stylesProvider';
import { ICON_COLORS } from 'styles/stylesProvider/themes';

type IcomoonIconProps = {
  name: string;
  size?: number;
  color?: ICON_COLORS;
};

/**
 * Icomoon icon class for SentinelOne icons. Icons are imported from the "font-mgmt" repo package.
 * To see a list of all available icons (currently 403 in number), add 'iconSet' to the IcomoonReact
 * imports and add the following line:
 *
 *   console.log(iconList(iconSet).sort().join('\n'));
 *
 * To see the icons, browse @sentinel-one/font-mgmt/demo.html
 *
 * @prop name    icon name (without prefix 'mgmt-' that appears in above demo page)
 * @prop size    size in pixels of one side (they are square); default to 15px
 * @prop color   theme color of the icon. define for ICON_COLORS; default to ICON_COLORS.ICOMOON
 *
 * @returns
 */
function IcomoonIcon({ name, size = 15, color = ICON_COLORS.ICOMOON }: IcomoonIconProps): JSX.Element {
  const iconStyles = useRecoilValue(iconStylesState);
  const iconColor = color === ICON_COLORS.NONE ? undefined : iconStyles[color];

  return <IcomoonReact iconSet={iconSet} icon={name} size={size} color={iconColor} />;
}

export default IcomoonIcon;
